<template>
  <section>
    <GroupTitle />
    <Feature :title="$t('SUBCONTRACT_STOCK_QUERY')" :iconClass="'fa-database'">
      <FormRow :fieldNameArr="['*' + $t('PLANT')]">
        <Select filterable v-model="plantCode" style="width: 200px" slot="a">
          <Option v-for="(item, index) in plantList" :value="item" :key="index">{{ item }}</Option>
        </Select>
      </FormRow>
      <ButtonRow>
        <Button type="primary" slot="0" @click="search">{{ $t('QUERY') }}</Button>
        <Button type="primary" slot="1" @click="download">{{ $t('DOWNLOAD_EXCEL') }}</Button>
      </ButtonRow>
      <TablePage :tableWidth="windowWidth" :columnsList="columnsList" :resultList="dataList" v-if="isData">
      </TablePage>
    </Feature>
  </section>
</template>

<script>
import { mapGetters } from "vuex"
import { mapActions } from "vuex"
import GroupTitle from "@/views/default/GroupTitle"
import { AlertInfo } from "@/util/alert"
import { Translate, DownloadFile, ExceptionHandling } from "@/util/common"

export default {
  name: "SubcontractStockQuery",
  components: {
    GroupTitle
  },
  created() {
    // 原本這寫法不可能拿到 getGroupCode 的 因為在 created 的時候還沒有 getGroupCode 就想判斷有沒有是不行的
    // 就先註解掉下面的啦
    // let vueInstance = this
    // if (vueInstance.getGroupCode()) {
    //   vueInstance.toggleLoading(true)
    //   vueInstance.$getPlantCode(vueInstance, vueInstance.getGroupCode().ecUuid).then(data => {
    //     vueInstance.toggleLoading(false)
    //     if (data) {
    //       data.forEach((plant) => {
    //         this.plantList.push(plant.objectKey)
    //       })
    //     } else {
    //       vueInstance.toggleLoading(false)
    //       AlertInfo(vueInstance, vueInstance.$t('COMMON_MESSAGE_NOT_AUTH')).then(() => {
    //       })
    //       vueInstance.$router.push("/home")
    //     }
    //   })
    // } else {
    //   vueInstance.$router.push("/home")
    // }
  },
  watch: {
    getGroupCode: {
      immediate: true,
      handler(group) {
        if (!group) return
        this.fetchPlant(group.ecUuid)
      }
    }
  },
  data() {
    return {
      plantList: [],
      plantCode: '',
      dataList: [],
      columnsList: [
        {
          renderHeader: (h, params) => {
            var text = this.$t("PLANT");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'plant',
          width: 80,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t("VENDOR");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'vendor',
          width: 100,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t("COMPONENT");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'componentViaSc',
          width: 100,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t("COMPONENT_DESCRIPTION");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'materialDescription',
          width: 320,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t("PO_REQ_DATE");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'requirementDate',
          width: 100,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t("REQ_QTY");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'requirementQty',
          width: 100,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t("AVAIL_SC_STOCK");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'availableStock',
          width: 100,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t("UNIT");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'unit',
          width: 100,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t("PO_NUMBER");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'poNo',
          width: 100,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t("PO_ITEM");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'poItemNo',
          width: 100,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t("DELIVERY");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'deliveryDate',
          width: 100,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t("PO_PART_NO");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'partNo',
          width: 100,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t("REPORT_DATE");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'reportDateTime',
          width: 180,
          align: "center",
        }
      ],
    }
  },
  methods: {
    ...mapGetters(["getUserProfile", "getLanguage", "getModalSize", "getWindowsWidth", "getGroupCode"]),
    ...mapActions(["toggleLoading"]),
    fetchPlant(ecUuid) {
      this.toggleLoading(true)
      this.$getPlantCode(this, ecUuid).then(data => {
        this.toggleLoading(false)
        if (data) {
          this.plantList = data.map(item => item.objectKey)
        } else {
          AlertInfo(this, this.$t('COMMON_MESSAGE_NOT_AUTH'))
        }
      })
    },
    search() {
      const vueInstance = this
      let errorMessage = vueInstance.valid(vueInstance.plantCode)

      if (errorMessage) {
        AlertInfo(vueInstance, errorMessage).then(() => {
        })
      } else {
        vueInstance.dataList = []
        vueInstance.toggleLoading(true)
        vueInstance.$consignmentHttp
          .get("/subcontract/query?plant=" + vueInstance.plantCode)
          .then((response) => {
            vueInstance.toggleLoading(false)
            if (response.data) {
              vueInstance.dataList = response.data._embedded.subcontractResourceList
            } else {
              vueInstance.$Notice.success({
                title: Translate("COMMON_MESSAGE_INFO"),
                desc: Translate("COMMON_MESSAGE_INFO"),
                render: h => {
                  return h('span', [
                    Translate("COMMON_TEXT_NOTHING")
                  ])
                }
              });
            }
          })
          .catch((error) => {
            vueInstance.toggleLoading(false)
            if (error.response.status == 444) {
              let text = vueInstance.$buildErrorMessage(error)
              vueInstance.$Swal.fire({
                icon: "error",
                title: Translate("COMMON_MESSAGE_ERROR"),
                text,
              })
            }
          })
      }
    },
    download() {
      let vueInstance = this
      vueInstance.toggleLoading(true)
      let errorMessage = vueInstance.valid(vueInstance.plantCode)

      if (errorMessage) {
        AlertInfo(vueInstance, errorMessage).then(() => {
        })
      } else {
        vueInstance.$consignmentHttp
          .get("subcontract/download?plant=" + vueInstance.plantCode, { responseType: 'blob' })
          .then((response) => {
            vueInstance.toggleLoading(false)
            DownloadFile(new Blob([response.data]), response.headers['content-disposition'].split('\"')[1])
          })
          .catch((error) => {
            vueInstance.toggleLoading(false)
            let blob = error.response.data
            if (blob.type.indexOf("application/json") > -1) {
              blob.text().then(temp => {
                if (typeof (temp) == 'string') {
                  let text = JSON.parse(temp).messages[0]
                  vueInstance.$Swal.fire({
                    icon: "error",
                    title: Translate("COMMON_MESSAGE_ERROR"),
                    text
                  })
                }
              });
            };
          })
      }
    },
    valid(plantCode) {
      let errorMessage = ""
      if (!plantCode) {
        errorMessage = errorMessage + this.$t('PLEASE_KEY_IN') + this.$t('PLANT') + " <br>"
      }
      return errorMessage
    },
  },
  computed: {
    modalSize() {
      return this.getModalSize()
    },
    isData() {
      return this.dataList && this.dataList.length > 0
    },
    windowWidth() {
      return this.getWindowsWidth() - 50
    },
    // 不再拿非方法來執行 因為原本就不是方法 是 getter
    groupCodeDesc() {
      const group = this.getGroupCode  
      return group ? group.code + " " + group.name : ""
    },
    getGroupCode() {
      return this.$store.getters.getGroupCode
    }
  }
}


</script>

<style scoped></style>
